exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2lWB17nDk2758A{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;line-height:16px;margin-top:16px;text-transform:uppercase;margin-top:0}._3I9o-wLYWuUhPA{margin:0 4px 4px 0}", ""]);

// exports
exports.locals = {
	"heading": "_2lWB17nDk2758A",
	"suggestedSearchButton": "_3I9o-wLYWuUhPA"
};